// Introspection data used to derive Apollo Client 3's `possibleTypes` cache map.
// The `description` field is retained from the schema dump even though the
// cache setup only reads each type's name.
type FragmentTypesIntrospectionData = {
  __schema: {
    types: {
      name: string;
      kind: string;
      possibleTypes: {
        name: string;
        description: string;
      }[];
    }[];
  };
};

const fragmentTypes: FragmentTypesIntrospectionData = {
  __schema: {
    types: [
      {
        name: 'BaseOrderingSettings',
        kind: 'INTERFACE',
        possibleTypes: [
          {
            name: 'InStorePickupOrderingSettings',
            description: '',
          },
          {
            name: 'CurbsidePickupOrderingSettings',
            description: '',
          },
          {
            name: 'DriveThruPickupOrderingSettings',
            description: '',
          },
          {
            name: 'DeliveryOrderingSettings',
            description: '',
          },
        ],
      },
      {
        name: 'PaymentsCheckoutCredentials',
        kind: 'UNION',
        possibleTypes: [
          {
            name: 'ChaseHostedProfileCredentials',
            description: '',
          },
          {
            name: 'MonerisHTProfileCredentials',
            description: '',
          },
        ],
      },
    ],
  },
};

export default fragmentTypes;
